/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import IMask from "imask";
import * as yup from 'yup';
import { cloneDeep } from 'lodash';
import moment from "moment";

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
};

function groupMultipleFieldQuestions({
  mainIdQuestion,
  questionnaire,
  handleQuestionsInitialAdjustments
}) {
  const groupQuestions = [];

  const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
  for (const mainQuestion of mainQuestions) {
    let group = []

    const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
    if (mainQuestionIndex || mainQuestionIndex == 0) group.push(questionnaire[mainQuestionIndex]);

    if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);

    if (mainQuestion.childrenQuestions) mainQuestion.childrenQuestions.map(childQuestion => group.push(childQuestion));

    group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    if (handleQuestionsInitialAdjustments) group = handleQuestionsInitialAdjustments({ questionnaire: group });

    groupQuestions.push(group.map((question, index) => ({ ...question, key: null })));
  }

  return groupQuestions;
}

function createSectionRow({
  questions
}) {
  questions = JSON.parse(JSON.stringify(questions));
  return questions.map(question => {
    const { defaultValue } = question.behaviorObject || {};
    question.answer = defaultValue || "";
    question.answerJson = defaultValue || "";
    question.idAnswerOption = null;
    question.idPerson = null;
    question.idQuestionnaireAnswers = null;
    question.idQuestionnaireAnswersParent = null;
    question.idQuestionnaireAnswersRoot = null;
    question.key = null;
    question.disabled = false;

    if (question.behaviorObject?.extraExclamationWarning) {
      question.behaviorObject.extraExclamationWarning = false;
    }

    return question;
  })
}

function removeMask({
  value,
  isPercentage = false,
  mask,
  maskPercentage,
}) {
  if (typeof value === "number" || !value) return value;

  let maskCurrency = IMask.createMask(isPercentage ? maskPercentage : mask);
  maskCurrency.resolve(value);
  var valueUnformated = maskCurrency.unmaskedValue;
  return parseFloat(valueUnformated);
}

function handleSave({
  values,
  questionnaire,
  obligorGroup,
  insurerGroup,
  feePayableByGroup,
  lossPayeeGroup,
  brokerRemunerationGroup,
  brokerRemunerationDeductionGroup,
  idOperation,
  idOperationParent,
  SECTIONS,
  isDraft,
  mc,
  formikRef,
  refQuestionnaireSent,
  useGetQuestionnairesAnswersRequest,
  useSaveQuestionnaireAnswerRequest,
  questionnaireAnswersToDelete,
  useDeleteQuestionnaireAnswerRequest,
  submitFunction
}) {

  buildValidation({
    values,
    questionnaire,
    obligorGroup,
    insurerGroup,
    feePayableByGroup,
    lossPayeeGroup,
    brokerRemunerationGroup,
    brokerRemunerationDeductionGroup,
    idOperation,
    idOperationParent,
    SECTIONS,
    isDraft,
    refQuestionnaireSent,
  }).validate(values, { abortEarly: false }).then(() => {
    const isValidSubmittedForm = handleValidationsSubmittedForm({
      values,
      questionnaire,
      setFieldError: formikRef.current.setFieldError,
      obligorGroup,
      insurerGroup,
      feePayableByGroup,
      lossPayeeGroup,
      brokerRemunerationGroup,
      brokerRemunerationDeductionGroup,
      SECTIONS,
      isDraft,
      mc,
    });

    if (isValidSubmittedForm) {
      handleSubmit({
        values,
        questionnaire,
        obligorGroup,
        insurerGroup,
        feePayableByGroup,
        lossPayeeGroup,
        brokerRemunerationGroup,
        brokerRemunerationDeductionGroup,
        idOperation,
        idOperationParent,
        onlyQuestions: false,
        SECTIONS,
        isDraft,
        refQuestionnaireSent,
        useGetQuestionnairesAnswersRequest,
        useSaveQuestionnaireAnswerRequest,
        questionnaireAnswersToDelete,
        useDeleteQuestionnaireAnswerRequest,
        submitFunction
      });
    }

  }).catch((error) => {
    onValidationError({
      error,
      mc,
      formikRef,
      questionnaire,
      groupQuestionnaires: [
        ...obligorGroup,
        ...insurerGroup,
        ...feePayableByGroup,
        ...lossPayeeGroup,
        ...brokerRemunerationGroup,
        ...brokerRemunerationDeductionGroup,
      ],
    })
  })
}

function buildValidation({
  values,
  questionnaire,
  obligorGroup,
  insurerGroup,
  feePayableByGroup,
  lossPayeeGroup,
  brokerRemunerationGroup,
  brokerRemunerationDeductionGroup,
  idOperation,
  idOperationParent,
  SECTIONS,
  isDraft,
  refQuestionnaireSent,
}) {
  const validationSchema = {};

  const validationQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    obligorGroup,
    insurerGroup,
    feePayableByGroup,
    lossPayeeGroup,
    brokerRemunerationGroup,
    brokerRemunerationDeductionGroup,
    onlyQuestions: true,
    SECTIONS,
  });

  let allQuestions = [...validationQuestionnaire];
  for (const question of allQuestions) {
    if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
  }

  for (const question of allQuestions) {
    if (isDraft && ![1378, 1379, 1380, 1381, 1382].includes(question.idQuestion)) continue;
    if ([614].includes(question?.idDomainQuestion)) continue;
    if (!question?.key) continue;

    question?.childrenQuestions?.map(item => {
      if (item.visibleQuestion && item.fieldMask?.type == 'phone' && item.behaviorObject?.isRequired) {
        validationSchema[item.key] = yup.string().test({
          name: "answer-validation",
          message: "Invalid phone",
          test: (value) => !!value && value.length >= 10
        })
      } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
        if (item.answer) {
          validationSchema[item.key] = yup.string().email('Invalid email').required("Required field")
        } else {
          if (item.behaviorObject?.isRequired) {
            validationSchema[item.key] = yup.string().email("Invalid email").required("Required field")
          } else {
            validationSchema[item.key] = yup.string().notRequired();
          }
        }
      } else {
        validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
          ? yup.string().test("answer-validation", "Required field", function (value) {
            return !!item.answer;
          }) : yup.string().notRequired();
      }
    })

    if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
      validationSchema[question.key] = yup.string().test({
        name: "answer-validation",
        message: "Invalid phone",
        test: (value) => !!value && value.length >= 10
      })
    } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
      if (question.answer) {
        validationSchema[question.key] = yup.string().email("Invalid email").required("Required field")
      } else {
        if (question.behaviorObject?.isRequired) {
          validationSchema[question.key] = yup.string().email("Invalid email").required("Required field")
        } else {
          validationSchema[question.key] = yup.string().notRequired();
        }
      }
    } else {
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().test("answer-validation", "Required field", function (value) {
          return !!question.answer;
        }) : yup.string().notRequired();
    }
  }

  return yup.object().shape(validationSchema);
}

function handleValidationsSubmittedForm({
  values,
  questionnaire,
  setFieldError,
  obligorGroup,
  insurerGroup,
  feePayableByGroup,
  lossPayeeGroup,
  brokerRemunerationGroup,
  brokerRemunerationDeductionGroup,
  SECTIONS,
  isDraft,
  mc,
}) {
  if (isDraft) return true;

  let validationResult = true;

  let totalObligorPercentage = 0;
  
  obligorGroup.forEach((group, index) => {
    const obligorPercentage = values[`$ANSWERS_OBLIGOR_PERC_${index}`]?.find((q) => q.idQuestion == 760)?.answer;
    totalObligorPercentage += obligorPercentage ? parseFloat(obligorPercentage) : 0;
  });

  if (totalObligorPercentage !== 100) {
    mc.error("The total obligor coding percentage should be 100%.");

    obligorGroup.forEach((group) => {
      const obligorPercentageQuestion = group.find((q) => q.idQuestion == 760);
      setFieldError(obligorPercentageQuestion.key, " ");
    });

    validationResult = false;
  }

  let allTaxesGrouped = questionnaire.find((question) => question.idQuestion === 1377)?.answer;
  let taxesQuestion = insurerGroup.map(tax => tax.filter((question) => question.idQuestion === 1378));
  
  let hasDuplicatedTax = false;
  let taxNames = [];
  
  if (allTaxesGrouped === "Yes") {
    taxesQuestion.map(tax => 
      tax.map(question => {
        if (taxNames.includes(question.childrenQuestions.find((tax) => tax.idQuestion === 1380)?.answer)) {
          hasDuplicatedTax = false;  //todo: revert
        } else {
          taxNames.push(question.childrenQuestions.find((tax) => tax.idQuestion === 1380)?.answer);
        }
      }
    ));
  } else {
    taxesQuestion.map(tax =>
      tax.map(question => {
        let obj = {
          nameInsurer: JSON.parse(question.answer)?.value,
          nameFacility: JSON.parse(question.childrenQuestions.find((tax) => tax.idQuestion === 1379)?.answer)?.value,
          taxName: JSON.parse(question.childrenQuestions.find((tax) => tax.idQuestion === 1380)?.answer)?.value,
        };

        if (!taxNames.length) {
          taxNames.push(obj);
        } else {
          let alreadyExistsTax = taxNames.find(
            (tax) => tax.nameInsurer === obj.nameInsurer && tax.nameFacility === obj.nameFacility && tax.taxName === obj.taxName
          );

          if (!alreadyExistsTax) {
            taxNames.push(obj);
          } else {
            hasDuplicatedTax = false;  //todo: revert
          }
        }
      }
    ));
  }

  if (hasDuplicatedTax) {
    mc.error("Duplicate taxes for the same insurer are not allowed!");
    validationResult = false;
  }

  let parsedSecondLloydsLeader;
  let parsedLloydsLeader;

  const lloydsLeader = questionnaire.find((question) => question.idQuestion === 1437)?.answer;
  const secondLloydsLeader = questionnaire.find((question) => question.idQuestion === 1443)?.answer;

  if (lloydsLeader) parsedLloydsLeader = JSON.parse(lloydsLeader) || {};
  if (secondLloydsLeader) parsedSecondLloydsLeader = JSON.parse(secondLloydsLeader) || {};

  if (parsedLloydsLeader && parsedSecondLloydsLeader && parsedLloydsLeader?.id === parsedSecondLloydsLeader?.id) {
    mc.error(`The Second Lloyds Leader and the Lloyds Leader could not be the same`);
    validationResult = false;
  }

  const updatedQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    obligorGroup,
    insurerGroup,
    feePayableByGroup,
    lossPayeeGroup,
    brokerRemunerationGroup,
    brokerRemunerationDeductionGroup,
    onlyQuestions: true,
    SECTIONS,
  });


  const facilityNames = questionnaire.filter((question) => question.idQuestion === 123);

  const inceptionDates = updatedQuestionnaire.filter((question) => question.idQuestion === 1880);
  const expiryDates = updatedQuestionnaire.filter((question) => question.idQuestion === 1881);
  const paymentDates = updatedQuestionnaire.filter((question) => question.idQuestion === 2018);
  const settlementDates = updatedQuestionnaire.filter((question) => question.idQuestion === 2019);

  let firstErrorKey = null;

  facilityNames.forEach((facilityName, facilityIndex) => {
    if (facilityName.answer) {
      const inceptionDate = inceptionDates.find((question) => question.facilityIndex === facilityIndex);
      const expiryDate = expiryDates.find((question) => question.facilityIndex === facilityIndex);

      if (inceptionDate?.answer && expiryDate?.answer) {
        const isValidDates = moment(inceptionDate?.answer, 'DD/MM/YYYY').isBefore(moment(expiryDate?.answer, 'DD/MM/YYYY'))
          || moment(inceptionDate?.answer, 'DD/MM/YYYY').isSame(moment(expiryDate?.answer, 'DD/MM/YYYY'));

        if (!isValidDates) {
          mc.error(`The Expiry Date should be greater than the Inception Date for facility ${facilityName.answer}`);
          setFieldError(inceptionDate.key, 'Invalid date');
          setFieldError(expiryDate.key, 'Invalid date');
          if (!firstErrorKey) firstErrorKey = inceptionDate.key;

          validationResult = false;
        }
      }

      const paymentDate = paymentDates.find((question) => question.facilityIndex === facilityIndex);
      const settlementDate = settlementDates.find((question) => question.facilityIndex === facilityIndex);

      if (paymentDate?.answer && settlementDate?.answer) {
        const isValidDates = moment(paymentDate?.answer, 'DD/MM/YYYY').isBefore(moment(settlementDate?.answer, 'DD/MM/YYYY'))
          || moment(paymentDate?.answer, 'DD/MM/YYYY').isSame(moment(settlementDate?.answer, 'DD/MM/YYYY'));

        if (!isValidDates) {
          mc.error(`The Settlement Date should be greater than the Payment Date for facility ${facilityName.answer}`);
          setFieldError(paymentDate.key, 'Invalid date');
          setFieldError(settlementDate.key, 'Invalid date');
          if (!firstErrorKey) firstErrorKey = paymentDate.key;

          validationResult = false;
        }
      }
    }
  })


  if (firstErrorKey) {
    const elements = global.window.document.getElementsByName(firstErrorKey);
    if (elements?.length) {
      setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
    }
  }

  return validationResult;
}

function onValidationError({
  error,
  mc,
  formikRef,
  questionnaire,
  groupQuestionnaires
}) {
  console.log('onValidationError catch initial', error)

  questionnaire = cloneDeep(questionnaire);
  groupQuestionnaires = cloneDeep(groupQuestionnaires);

  mc.error('Please complete all required fields to proceed.')
  const allQuestions = questionnaire;

  groupQuestionnaires.forEach((grpQuestionnaire) => {
    Array.isArray(grpQuestionnaire)
      ? grpQuestionnaire.map(question => allQuestions.push(question))
      : grpQuestionnaire.questions.map(question => allQuestions.push(question))
  });

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    error.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);

      if (question.dsQuestion === "E-mail") {
        mc.error(`The email entered is invalid`);
        formikRef.current.setFieldError(question.key, `* Invalid email`);
      } else {
        mc.error(`The Field: ${question.dsQuestion} is required`);
        formikRef.current.setFieldError(question.key, `* Required field`);
      }

      if (!firstErrorKey) firstErrorKey = question.key;
    });

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}

function handleQuestionnaireAnswerToSave({
  values,
  questionnaire,
  obligorGroup,
  insurerGroup,
  feePayableByGroup,
  lossPayeeGroup,
  brokerRemunerationGroup,
  brokerRemunerationDeductionGroup,
  onlyQuestions,
  SECTIONS,
}) {
  const formValues = JSON.parse(JSON.stringify(values)) || {};

  let questionnaireAnswers = []

  for (const [, section] of Object.entries(SECTIONS)) {
    if (section.isMultiple) {
      let multipleFields = []
      switch (section.name) {
        case 'OBLIGOR_PERC':
          multipleFields = cloneDeep(obligorGroup);
          break;
        case 'INSURER_TAXES':
          multipleFields = cloneDeep(insurerGroup);
          break;
        case 'FEE_PAYABLE_BY':
          multipleFields = cloneDeep(feePayableByGroup);
          break;
        case 'LOSS_PAYEE':
          multipleFields = cloneDeep(lossPayeeGroup);
          break;
        case 'BROKER_REMUNERATION':
          multipleFields = cloneDeep(brokerRemunerationGroup);
          break;
        case 'BROKER_REMUNERATION_DEDUCTION':
          multipleFields = cloneDeep(brokerRemunerationDeductionGroup);
          break;
        default:
          multipleFields = [];
          break;
      }

      multipleFields.map((field, index) => {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
        if (sectionAnswers?.length) {
          const rootQuestion = sectionAnswers.find((question) => !question.idQuestionRoot);
          const childrenQuestions = sectionAnswers.filter((question) => question.idQuestionRoot);
          rootQuestion.childrenQuestions = childrenQuestions;
          if (!onlyQuestions) {
            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
          } else {
            questionnaireAnswers = [...questionnaireAnswers, ...sectionAnswers];
          }
        }
      });
    } else {
      let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
      if (sectionAnswers) {
        questionnaireAnswers = [...questionnaireAnswers, ...sectionAnswers];
      }
    }
  }

  let childrenQuestionIds = [];
  for (const question of questionnaireAnswers) {
    if (question) {
      if (
        (question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer
      ) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }

      if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
        if (question?.childrenQuestions?.length) {
          const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
          childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
        }
      } else {
        question.childrenQuestions = [];
      }
    }
  }

  questionnaireAnswers = questionnaireAnswers.filter(v => !childrenQuestionIds.includes(v.idQuestion))

  return questionnaireAnswers;
}

function handleSubmit({
  values,
  questionnaire,
  obligorGroup,
  insurerGroup,
  feePayableByGroup,
  lossPayeeGroup,
  brokerRemunerationGroup,
  brokerRemunerationDeductionGroup,
  idOperation,
  idOperationParent,
  onlyQuestions,
  SECTIONS,
  isDraft,
  refQuestionnaireSent,
  useGetQuestionnairesAnswersRequest,
  useSaveQuestionnaireAnswerRequest,
  questionnaireAnswersToDelete,
  useDeleteQuestionnaireAnswerRequest,
  submitFunction
}) {

  if (refQuestionnaireSent.current) return;

  refQuestionnaireSent.current = true;

  const validQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    obligorGroup,
    insurerGroup,
    feePayableByGroup,
    lossPayeeGroup,
    brokerRemunerationGroup,
    brokerRemunerationDeductionGroup,
    onlyQuestions,
    SECTIONS,
  });

  useSaveQuestionnaireAnswerRequest(validQuestionnaire)
    .then((resp) => {
      if (resp.status === 200) {
        if (idOperation && questionnaireAnswersToDelete?.length) {
          useDeleteQuestionnaireAnswerRequest({ ids: questionnaireAnswersToDelete })
            .then(() => {})
        } else {
          useGetQuestionnairesAnswersRequest();
        }

        if (!isDraft && submitFunction) {
          submitFunction();
        } else {
          window.location.reload();
        }
      }
    })
    .catch((e) => {
      console.log('handleSubmit - error', e)
    })
    .finally(() => {
      refQuestionnaireSent.current = false;
    });
}

function getManagedByOptions({ questionnaire }) {
  if (!questionnaire?.length) return [];

  const options = [];

  const leadingOfficeQuestionnaireAnswer = questionnaire.find((question) => question.idQuestion === 124);

  if (leadingOfficeQuestionnaireAnswer?.answer && leadingOfficeQuestionnaireAnswer?.idAnswerOption) {
    options.push({
      value: leadingOfficeQuestionnaireAnswer?.idAnswerOption,
      label: leadingOfficeQuestionnaireAnswer?.answer,
    })
  }

  const surplusBrokerQuestionnaireAnswer = questionnaire.find((question) => question.idQuestion === 182);

  if (surplusBrokerQuestionnaireAnswer?.answer) {
    const parsedAnswer = JSON.parse(surplusBrokerQuestionnaireAnswer?.answer);

    options.push({
      value: parsedAnswer?.idPerson,
      label: parsedAnswer?.namePerson,
    })
  }

  const thirdPartyQuestionnaireAnswer = questionnaire.find((question) => question.idQuestion === 183);

  if (thirdPartyQuestionnaireAnswer?.answer) {
    const parsedAnswer = JSON.parse(thirdPartyQuestionnaireAnswer?.answer);

     options.push({
      value: parsedAnswer?.idPerson,
      label: parsedAnswer?.namePerson,
    })
  }

  return options
}

const events = {
  handleInitialAdjustments,
  groupMultipleFieldQuestions,
  createSectionRow,
  removeMask,
  handleSave,
  getManagedByOptions,
};

export { events };